import { http } from '@pendo/http';

export function createIntegrationKey ({ integrationKey }) {
    return http.post('/api/s/_SID_/integrationkey', integrationKey);
}

export function fetchIntegrationKeys () {
    return http.get('/api/s/_SID_/integrationkey');
}

export function deleteIntegrationKey ({ id }) {
    return http.delete(`/api/s/_SID_/integrationkey/${id}`);
}
